import { render, staticRenderFns } from "./sp-footer.vue?vue&type=template&id=6a25cbf9&scoped=true"
import script from "./sp-footer.vue?vue&type=script&lang=js"
export * from "./sp-footer.vue?vue&type=script&lang=js"
import style0 from "./sp-footer.vue?vue&type=style&index=0&id=6a25cbf9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25cbf9",
  null
  
)

export default component.exports